// Generated for @nava/participant-copy: Clair's default texts in Polish. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Polish. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_PL = {
    'landing.changeLanguage': 'Zmień język',
    'common.language': 'Język',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Możesz rozmawiać z Clair w ponad 80 językach.',
    'common.seeLanguages': 'Zobacz listę',
    'footer.poweredBy': 'Obsługiwane przez',
    'landing.heading': 'Zapraszamy na krótką rozmowę.',
    'landing.intro': 'Firma {company} chciałaby usłyszeć, jak Ci idzie. Porozmawiasz z Clair, asystentką AI, kiedy Ci pasuje.',
    'landing.continue': 'Kontynuuj',
    'preflight.title': 'Potrzebujemy jeszcze kilku rzeczy',
    'preflight.checkInSubtitle': 'Przejdź przez poniższą listę, aby zacząć rozmowę.',
    'preflight.actions.expandItem': 'Rozwiń {{item}}',
    'preflight.microphone.title': 'Dostęp do mikrofonu',
    'preflight.microphone.checkInPrivacy': 'Twój głos służy do rozmowy z Clair, asystentką AI. Rozmowa jest nagrywana i transkrybowana, a jej zapis otrzymuje {company}. Wszystkie dane są szyfrowane i bezpiecznie przechowywane.',
    'preflight.microphone.readMore': 'Dowiedz się więcej',
    'preflight.microphone.grantAccess': 'Zezwól na dostęp',
    'preflight.microphone.indicatorAction': 'Zezwól na dostęp do mikrofonu',
    'preflight.microphone.accessGranted': 'Dostęp przyznany',
    'preflight.microphone.errorHelper': 'Sprawdź ustawienia przeglądarki i spróbuj ponownie.',
    'preflight.microphone.browserNotSupported': 'Twoja przeglądarka nie obsługuje nagrywania dźwięku. Użyj Chrome, Firefox lub Safari.',
    'preflight.terms.title': 'Prywatność i zgoda',
    'preflight.terms.checkInPrivacy': 'Tę rozmowę prowadzi Clair, asystentka AI, a jej organizatorem jest {company}. Twoje odpowiedzi otrzymuje {company}. Nigdy nie są one wykorzystywane do celów reklamowych. Możesz przerwać w dowolnym momencie.',
    'preflight.terms.readMore': 'Dowiedz się więcej',
    'preflight.terms.accept': 'Tak, akceptuję',
    'preflight.terms.indicatorAction': 'Zaakceptuj prywatność i zgodę',
    'preflight.terms.accepted': 'Zaakceptowano',
    'preflight.terms.rememberConsent': 'Zapamiętaj moją zgodę przez 30 dni',
    'preflight.terms.rememberConsentCallTooltip': 'Zgoda jest zapisywana tylko dla tej rozmowy, w tej przeglądarce, na 30 dni.',
    'quickStart.agree': 'Zgadzam się',
    'quickStart.back': 'Wstecz',
    'quickStart.cancel': 'Anuluj',
    'preflight.startCheckIn': 'Zacznij rozmowę',
    'preflight.preparingCheckIn': 'Przygotowujemy rozmowę...',
    'preflight.preparingCheckInDelayedTitle': 'Przygotowujemy rozmowę.',
    'preflight.preparingCheckInDelayedSubtitle': 'Nadal pracujemy, prosimy czekać.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'To trwa dłużej niż oczekiwano.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Prosimy o cierpliwość.',
    'preflight.checkInPreparationFailedTitle': 'Nie udało się przygotować rozmowy',
    'preflight.checkInPreparationFailedMessage': 'Nie udało się wczytać niektórych plików rozmowy. Sprawdź połączenie i spróbuj ponownie.',
    'preflight.retryPreparation': 'Spróbuj ponownie',
    'interview.status.connecting': 'Łączenie',
    'interview.status.speaking': 'Mówi',
    'interview.status.listening': 'Słucha',
    'interview.status.thinking': 'Myśli',
    'interview.question': 'Pytanie {{current}} z {{total}}',
    'interview.mainQuestion': 'Pytanie główne {{current}} z {{total}}',
    'interview.recording': 'Twoja odpowiedź jest nagrywana...',
    'interview.endInterview': 'Zakończ rozmowę',
    'interview.muteTooltip': 'Wycisz mikrofon',
    'interview.unmuteTooltip': 'Włącz mikrofon',
    'interview.pauseTooltip': 'Zrób przerwę',
    'interview.resumeTooltip': 'Wznów rozmowę',
    'interview.subtitleTooltip.show': 'Pokaż napisy (CC)',
    'interview.subtitleTooltip.hide': 'Ukryj napisy (CC)',
    'interview.toggleChat': 'Pisz zamiast mówić',
    'interview.toggleVoice': 'Mów zamiast pisać',
    'interview.chatTooltip.type': 'Wpisz odpowiedź zamiast mówić',
    'interview.chatTooltip.speak': 'Powiedz odpowiedź zamiast pisać',
    'interview.chatTooltip.unavailable': 'Dostępne po połączeniu',
    'interview.chatDiscoveryHint': 'Nie możesz mówić? Dotknij, aby pisać',
    'interview.chatPlaceholder': 'Wpisz wiadomość...',
    'interview.sendMessage': 'Wyślij',
    'interview.chat.warmHeader': 'Nie spiesz się, poczekam, aż napiszesz',
    'interview.chat.newlineHint': 'Shift + Enter, aby dodać nową linię',
    'interview.chat.aiVoiceOn': 'Głos włączony',
    'interview.chat.aiVoiceOff': 'Głos wyłączony',
    'interview.chat.backToVoice': 'Wróć do głosu',
    'interview.audio.controls': 'Ustawienia dźwięku',
    'interview.audio.callVolume': 'Głośność rozmowy',
    'interview.audio.muteSpeaker': 'Wycisz głośnik',
    'interview.audio.unmuteSpeaker': 'Włącz dźwięk głośnika',
    'interview.audio.microphone': 'Mikrofon',
    'interview.audio.speaker': 'Głośnik',
    'interview.audio.device': 'Urządzenie audio',
    'interview.audio.linkedRouting': 'Telefon steruje mikrofonem i głośnikiem jednocześnie.',
    'interview.audio.phoneSpeaker': 'Głośnik telefonu',
    'interview.audio.phoneEarpiece': 'Słuchawka telefonu',
    'interview.audio.bluetoothHeadset': 'Słuchawki Bluetooth',
    'interview.audio.wiredHeadset': 'Słuchawki przewodowe',
    'interview.audio.usbAudio': 'Dźwięk USB',
    'interview.audio.systemDefault': 'Domyślne ustawienie systemu',
    'interview.audio.changeFailed': 'Nie udało się zmienić urządzenia audio.',
    'interview.networkQuality.excellent': 'Jakość połączenia jest doskonała.',
    'interview.networkQuality.good': 'Jakość połączenia jest dobra.',
    'interview.networkQuality.poor': 'Jakość połączenia jest słaba.',
    'interview.networkQuality.bad': 'Jakość połączenia jest bardzo słaba.',
    'interview.networkQuality.offline': 'Połączenie jest offline.',
    'interview.pauseModal.title': 'Rozmowa wstrzymana',
    'interview.pauseModal.timeRemaining': 'Pozostało {{time}}',
    'interview.pauseModal.timeoutWarning': 'Jeśli pauza potrwa dłużej, rozmowa wkrótce zakończy się sama.',
    'interview.pauseModal.resume': 'Wznów rozmowę',
    'interview.pauseModal.end': 'Zakończ rozmowę',
    'interview.endConfirm.title': 'Zakończyć rozmowę?',
    'interview.endConfirm.body': 'Po zakończeniu nie będzie można wrócić. Dotychczasowy postęp zostanie zapisany.',
    'interview.endConfirm.cancel': 'Kontynuuj rozmowę',
    'interview.endConfirm.end': 'Zakończ rozmowę',
    'complete.checkInTitle': 'Dziękujemy za poświęcony czas',
    'complete.checkInMessage': 'Twoje odpowiedzi trafią do zespołu firmy {company}.',
    'studyClosed.checkInTitle': 'Ta rozmowa jest zamknięta',
    'studyClosed.checkInMessage': 'Dziękujemy za zainteresowanie, rozmowa nie przyjmuje już odpowiedzi.',
    'studyNotOpen.checkInTitle': 'Ta rozmowa nie jest jeszcze otwarta',
    'studyNotOpen.checkInMessage': 'Spróbuj otworzyć link później.',
    'studyNotReady.checkInTitle': 'Ta rozmowa jest prawie gotowa',
    'studyNotReady.checkInMessage': 'Spróbuj otworzyć link za kilka minut.',
    'participantLinkCompleted.checkInTitle': 'Ta rozmowa już się odbyła',
    'participantLinkCompleted.checkInMessage': 'Dziękujemy za poświęcony czas, nie musisz nic więcej robić.',
    'loading.interview': 'Wczytujemy rozmowę...',
    'browserHelp.title': 'Otwórz w przeglądarce',
    'browserHelp.description': 'Wbudowana przeglądarka tej aplikacji może ograniczać dostęp do mikrofonu. Aby zapewnić najlepsze działanie, otwórz link w {{browserOptions}}.',
    'browserHelp.namedDescription': 'Wbudowana przeglądarka aplikacji {{app}} może ograniczać dostęp do mikrofonu. Aby zapewnić najlepsze działanie, otwórz link w {{browserOptions}}.',
    'browserHelp.appleBrowsers': 'Safari lub Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge lub Chrome',
    'browserHelp.otherBrowsers': 'Chrome lub innej przeglądarce',
    'browserHelp.openSafari': 'Otwórz w Safari',
    'browserHelp.copyLink': 'Kopiuj link',
    'browserHelp.copied': 'Link skopiowany. Wklej go w przeglądarce.',
    'browserHelp.manualCopy': 'Nie udało się skopiować automatycznie. Zaznacz i skopiuj link poniżej.',
    'browserHelp.copyInstructions': 'Skopiuj poniższy link i wklej go w innej przeglądarce. Możesz też poszukać w menu aplikacji opcji otwarcia tej strony w domyślnej przeglądarce.',
    'browserHelp.linkLabel': 'Link do rozmowy',
    'browserHelp.continueAnyway': 'Kontynuuj mimo to',
    'preflight.microphone.recovery.denied': 'Odmowa dostępu do mikrofonu.',
    'preflight.microphone.recovery.timedOut': 'Żądanie dostępu do mikrofonu trwało zbyt długo. Sprawdź, czy przeglądarka wyświetla prośbę o uprawnienia, i spróbuj ponownie.',
    'preflight.microphone.recovery.notFound': 'Nie znaleziono mikrofonu. Podłącz mikrofon i spróbuj ponownie.',
    'preflight.microphone.recovery.notReadable': 'Nie udało się uruchomić mikrofonu. Zamknij inne aplikacje, które go używają, i spróbuj ponownie.',
    'preflight.microphone.recovery.failed': 'Nie udało się uzyskać dostępu do mikrofonu. Sprawdź mikrofon i spróbuj ponownie.',
    'preflight.microphone.recovery.retry': 'Spróbuj ponownie',
    'preflight.microphone.recovery.close': 'Zamknij',
    'preflight.microphone.recovery.helpTitle': 'Zezwól na dostęp do mikrofonu',
    'preflight.microphone.recovery.helpDescription': 'Dostęp do mikrofonu jest nadal zablokowany. Przeglądarka mogła zapamiętać wcześniejszy wybór i nie wyświetlać ponownie prośby o zgodę.',
    'preflight.microphone.recovery.safariMacSettings': 'Na pasku menu Safari wybierz Safari > Ustawienia > Witryny > Mikrofon. Znajdź tę witrynę na liście.',
    'preflight.microphone.recovery.chromiumSettings': 'Kliknij ikonę ustawień witryny po lewej stronie paska adresu, a następnie wybierz Ustawienia witryny > Mikrofon.',
    'preflight.microphone.recovery.siteSettings': 'Otwórz uprawnienia tej witryny za pomocą ikony lub menu obok paska adresu albo w ustawieniach witryn przeglądarki.',
    'preflight.microphone.recovery.allowMicrophone': 'Zezwól tej witrynie na dostęp do mikrofonu, wróć tutaj i wybierz „Spróbuj ponownie”. Jeśli przeglądarka poprosi o ponowne załadowanie strony, zrób to.',
    'preflight.microphone.recovery.deviceSettings': 'Jeśli dostęp jest już dozwolony, sprawdź w ustawieniach urządzenia, czy ta przeglądarka może używać mikrofonu.',
    'microphoneQuality.title': 'Jakość mikrofonu',
    'microphoneQuality.instructions': 'Zacznij mówić przez kilka sekund, abyśmy mogli sprawdzić, jak dobrze Cię słyszymy.',
    'microphoneQuality.recoveryMessage': 'Nie słyszymy Cię. Jeśli prowadzisz rozmowę telefoniczną, najpierw ją zakończ. Zamknij inne aplikacje korzystające z mikrofonu i spróbuj ponownie.',
    'microphoneQuality.poor': 'Słaba',
    'microphoneQuality.almostThere': 'Prawie dobrze',
    'microphoneQuality.perfect': 'Idealnie!',
    'microphoneQuality.waiting': 'Oczekiwanie na dźwięk...',
    'microphoneQuality.from': 'Z',
    'microphoneQuality.defaultDevice': 'Domyślny mikrofon',
    'microphoneQuality.helpText': 'Mów głośniej lub przysuń się bliżej mikrofonu',
    'microphoneQuality.done': 'Gotowe',
    'startupRecovery.title': 'Nie udało się rozpocząć rozmowy',
    'startupRecovery.failed': 'Nie udało się połączyć z usługą rozmów. Spróbuj ponownie.',
    'startupRecovery.timedOut': 'Nawiązywanie połączenia trwało zbyt długo. Spróbuj ponownie.',
    'startupRecovery.cancelled': 'Połączenie zostało anulowane. Możesz spróbować ponownie, gdy będziesz gotowy.',
    'startupRecovery.microphone': 'Nie udało się uzyskać dostępu do mikrofonu. Sprawdź uprawnienia i spróbuj ponownie.',
    'startupRecovery.delayed': 'Nadal trwa łączenie. Zajmuje to więcej czasu niż zwykle…',
    'startupRecovery.retry': 'Spróbuj ponownie',
    'startupRecovery.support': 'Numer referencyjny dla pomocy technicznej',
    'startupRecovery.copy': 'Kopiuj numer',
    'startupRecovery.copied': 'Skopiowano',
    'startupRecovery.checking': 'Sprawdzanie połączenia…',
    'startupRecovery.unavailable': 'Nie udało się potwierdzić',
    'startupRecovery.advice': 'Ten test sprawdza tylko dostępność usług. Nadal możesz spróbować rozpocząć. Jeśli się nie uda, wypróbuj inną przeglądarkę lub sieć.',
    'startupRecovery.checkAgain': 'Sprawdź połączenie ponownie...',
    'connectionDetails.quality': 'Jakość sieci',
    'connectionDetails.excellent': 'Doskonała',
    'connectionDetails.good': 'Dobra',
    'connectionDetails.poor': 'Słaba',
    'connectionDetails.bad': 'Zła',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Nie sprawdzono',
    'connectionDetails.lastChecked': 'Ostatnie sprawdzenie',
    'connectionDetails.warning': 'Nie udało się potwierdzić połączenia: {{services}}.',
    'connectionDetails.navaApi': 'API Clair',
    'connectionDetails.interviewApi': 'Usługa rozmów Clair',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Odśwież test połączenia',
    'connectionDetails.success': 'Test połączenia zakończony pomyślnie.',
    'connection.error': 'Błąd połączenia',
    'connection.errorDefault': 'Nie udało się połączyć z usługą rozmów',
    'connection.retry': 'Spróbuj ponownie',
    'versionRefresh.message': 'Dostępna jest nowa wersja. Odśwież przeglądarkę, gdy będziesz gotowy.',
    'versionRefresh.action': 'Odśwież',
    'cookies.banner.title': 'Cenimy Twoją prywatność',
    'cookies.banner.message': 'Używamy plików cookie, aby optymalizować Twoje doświadczenie, rozumieć użycie produktu i wspierać odpowiedni marketing. Wybierz <bold>„Akceptuj wszystko”</bold>, aby wyrazić zgodę na wszystkie pliki cookie, lub <bold>„Zarządzaj preferencjami”</bold>, aby dostosować ustawienia.',
    'cookies.banner.privacyPolicy': 'Polityka prywatności',
    'cookies.banner.acceptAll': 'Akceptuj wszystko',
    'cookies.banner.managePreferences': 'Zarządzaj preferencjami',
    'cookies.modal.title': 'Ustawienia cookie',
    'cookies.modal.description': 'Gdy odwiedzasz Clair, możemy zapisywać lub odczytywać dane o Tobie za pomocą plików cookie i podobnych technologii. Niezbędne pliki cookie zapewniają działanie strony. Opcjonalne ustawienia możesz zmienić w dowolnym momencie.',
    'cookies.modal.readMore': 'Przeczytaj więcej w naszej',
    'cookies.modal.save': 'Zapisz',
    'cookies.modal.close': 'Zamknij preferencje cookie',
    'cookies.modal.essential.title': 'Niezbędne',
    'cookies.modal.essential.description': 'Wymagane do podstawowego działania strony. Niezbędnych plików cookie nie można wyłączyć.',
    'cookies.modal.analytics.title': 'Analityka',
    'cookies.modal.analytics.description': 'Pomaga Clair zrozumieć, jak działa strona, jak korzystają z niej odwiedzający i czy mogą występować problemy techniczne.',
    'invitation.subject': 'Firma {company} zaprasza na krótką rozmowę',
    'invitation.greeting': 'Cześć {name},',
    'invitation.body': 'Chcielibyśmy usłyszeć, jak Ci idzie.',
    'invitation.aiNotice': 'Porozmawiasz z Clair, naszą asystentką AI. Większości osób łatwiej jest mówić szczerze do AI niż do człowieka, a możesz to zrobić, kiedy Ci pasuje, w pracy albo w domu.',
    'invitation.button': 'Zacznij rozmowę',
    'invitation.fallbackLink': 'Albo wklej ten link do przeglądarki:',
    'invitation.footer': 'Otrzymujesz tę wiadomość, ponieważ korzystasz z usług firmy {company}. Rozmowę prowadzi w jej imieniu Clair, asystentka AI.',
    'invitation.optOut': 'Nie wysyłaj mi tego więcej',
    'sms.invite': 'Firma {company} zaprasza na krótką rozmowę:',
    'sms.stop': 'Zrezygnuj z SMS:',
};
//# sourceMappingURL=pl.js.map